import React, {
  createContext,
  useEffect,
  useState,
  useMemo,
} from 'react'
import axios from 'axios'
import useIsMounted from '../../hooks/useIsMounted'
import apiConfig from '../../config/api-config'
import localConfig from '../../config/local-config'
import nrLogger from '../helpers/nrLogger'

export const VehicleSpecificationsContext = createContext()
export default function VehicleSpecificationProvider({ children, vehicle, vehicleSpecs }) {
  const isMounted = useIsMounted()
  const isDataPresent = Boolean(vehicleSpecs)
  const [vehicleSpecifications, setVehicleSpecifications] = useState(() => {
    if (isDataPresent) return vehicleSpecs
    return []
  })
  const baseUrl = apiConfig.apiURL
  const contextValue = useMemo(
    () => ({
      vehicleSpecifications,
      setVehicleSpecifications,
    }),
    [
      vehicleSpecifications,
      setVehicleSpecifications,
    ],
  )
  useEffect(() => {
    if (isDataPresent) {
      return
    }
    if (vehicle && !isDataPresent) {
      const { year, make, model } = vehicle
      const url = `${baseUrl}/v1/vehicle-specifications`
      axios.get(url, {
        params: {
          domain: localConfig.hostname,
          year,
          make,
          model,
        },
        headers: {
          apikey: apiConfig.apiKey,
        },
      }).then(result => {
        const { data: responseData } = result
        if (isMounted()) {
          setVehicleSpecifications(responseData.data.vehicleSpecifications)
        }
      }).catch(err => {
        if (axios.isCancel(err)) {
          nrLogger.error('Warning fetching Vehicle Specifications', err)
        } else {
          nrLogger.error('Error fetching Vehicle Specifications', err)
        }
      })
    }
  }, [baseUrl, vehicle, isDataPresent, isMounted])
  return (
    <VehicleSpecificationsContext.Provider value={contextValue}>
      { children }
    </VehicleSpecificationsContext.Provider>
  )
}
